import { render, staticRenderFns } from "./ManageEdit.vue?vue&type=template&id=89e67002&scoped=true&"
import script from "./ManageEdit.vue?vue&type=script&lang=js&"
export * from "./ManageEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e67002",
  null
  
)

export default component.exports